var keys = {
    BOX_fetchingChannels: "BOX_fetchingChannels",
    BOX_setUpInbox: "BOX_setUpInbox",
    BOX_loadingText: "BOX_loadingText",
    BOX_selectTheNumbers: "BOX_selectTheNumbers",
    BOX_apiKeyWarning: "BOX_apiKeyWarning",
    BOX_createBtn: "BOX_createBtn",
    BOX_selectInboxLabel: "BOX_selectInboxLabel",
    BOX_buttonLabelConnectNew: "BOX_buttonLabelConnectNew",
    BOX_disclaimerOneNumber: "BOX_disclaimerOneNumber",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ3BDLG9CQUFvQixFQUFFLHNCQUFzQjtJQUM1QyxjQUFjLEVBQUUsZ0JBQWdCO0lBQ2hDLGVBQWUsRUFBRSxpQkFBaUI7SUFDbEMsb0JBQW9CLEVBQUUsc0JBQXNCO0lBQzVDLGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxhQUFhLEVBQUUsZUFBZTtJQUM5QixvQkFBb0IsRUFBRSxzQkFBc0I7SUFDNUMseUJBQXlCLEVBQUUsMkJBQTJCO0lBQ3RELHVCQUF1QixFQUFFLHlCQUF5QjtDQUNuRCxDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==